<template >
  <div style="">
    <div >


      <VideoGreet style="position:fixed;">



      </VideoGreet>








      <svg  :style="{'margin-top':$vuetify.breakpoint.mdAndUp? '400px':'550px'}" style="position:relative;z-index: 1;margin-bottom:0;pointer-events: none;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#e7e7e7" fill-opacity="1" d="M0,256L80,261.3C160,267,320,277,480,240C640,203,800,117,960,69.3C1120,21,1280,11,1360,5.3L1440,0L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>

      </svg>


      <v-row class="px-12" style="background:#e7e7e7;position: relative;margin-top: -10px;z-index: 1;padding-bottom:80px;">

          <div  @click="$router.push('/donations')" style="cursor: pointer;" v-ripple class="clickable col-sm-6 col-md-3 col-12">
          <div style="top:200px;" class="container pa-0">
            <div class="row no-gutters justify-center">
              <div class="mb-4 col col-12 text-center">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-gift"  style="font-size: 56px;color:#8c74ba;"></i>
              </div>
              <div class="col col-12">
                <h3 class="text-uppercase title font-weight-bold mb-1 text-center" style="color:#8c74ba;"> Donationer</h3>
                <div class="v-responsive base-divider mx-auto mb-6" style="max-width: 28px;">
                  <div class="v-responsive__content"><hr style="background:#8c74ba;" role="separator" aria-orientation="horizontal" class="v-divider theme--dark"></div>
                </div>
                <div class="text-center overline" style="color:#8c74ba;">
                  Du skapar snabbt och enkelt din egen Hihat-sida och kan därefter omedelbart ta emot notiser betalda med Swish.

                </div>

              </div>
            </div>
          </div>
        </div>

        <div @click="$router.push('/spons')" style="cursor: pointer;" class="clickable col-sm-6 col-md-3 col-12">
          <div class="container pa-0">
            <div class="row no-gutters justify-center">
              <div class="mb-4 col col-12 text-center">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-handshake theme--dark"  style="font-size: 56px;color:#878cac;"></i>
              </div>
              <div class="col col-12">
                <h3 class="text-uppercase title font-weight-bold mb-1 text-center" style="color:#878cac">Spons</h3>
                <div class="v-responsive base-divider  mx-auto mb-6" style="max-width: 28px;">
                  <div class="v-responsive__content"><hr style="background:#878cac" role="separator" aria-orientation="horizontal" class="v-divider theme--dark"></div>
                </div>
                <div class="text-center overline" style="color:#878cac;">
                 Engagera dina tittare och ta del av exklusiva sponsorerbjudanden.

                </div>

              </div>
            </div>
          </div>
        </div>
        <div @click="$router.push('/events')" style="cursor: pointer;" class="clickable col-sm-6 col-md-3 col-12">
          <div class="container pa-0">
            <div class="row no-gutters justify-center">
              <div class="mb-4 col col-12 text-center">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-calendar-star" style="font-size: 56px;color:#729d9f;"></i>
              </div>
              <div class="col col-12">
                <h3 class="text-uppercase title font-weight-bold mb-1 text-center" style="color:#729d9f;"> Events</h3>
                <div class="v-responsive base-divider mx-auto mb-6" style="max-width: 28px;">
                  <div class="v-responsive__content"><hr style="background:#729d9f;" role="separator" aria-orientation="horizontal" class="v-divider theme--dark"></div>
                </div>
                <div class="text-center overline" style="color:#729d9f;">
                  Bidra till ett bättre community och ett bättre samhälle genom välgörenhetsstreams

                </div>
              </div>
            </div>
          </div>
        </div>
        <div @click="$router.push('/streamhotel')" style="cursor: pointer;" class="clickable col-sm-6 col-md-3 col-12">

          <div class="container pa-0">

            <div class="row no-gutters justify-center">
              <div class="mb-4 col col-12 text-center">
                <i aria-hidden="true" class="v-icon notranslate mdi mdi-controller-classic"  style="font-size: 56px;color:#6eb19e;"></i>
              </div>
              <div class="col col-12">
                <h3 class="text-uppercase title font-weight-bold mb-1 text-center" style="color:#6eb19e;"> Stream Hotel</h3>
                <div class="v-responsive base-divider mx-auto mb-6" style="max-width: 28px;">
                  <div class="v-responsive__content"><hr role="separator" aria-orientation="horizontal" style="background:#6eb19e;" class="v-divider theme--dark"></div>
                </div>
                <div class="text-center overline" style="color:#6eb19e;">
                  Stream Hotel är ett 3D-multiplayer-spel som spelas i en overlay ovanför din stream

                </div>

              </div>
            </div>
          </div>
        </div>

      </v-row>
      <svg style="position:relative;z-index: 1;margin-bottom:0;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#e7e7e7" fill-opacity="1" d="M0,96L120,85.3C240,75,480,53,720,42.7C960,32,1200,32,1320,32L1440,32L1440,0L1320,0C1200,0,960,0,720,0C480,0,240,0,120,0L0,0Z"></path>
      </svg>
      <!---<svg   style="position:relative;z-index: 1;margin-bottom:0;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#e7e7e7" fill-opacity="1" d="M0,256L80,261.3C160,267,320,277,480,240C640,203,800,117,960,69.3C1120,21,1280,11,1360,5.3L1440,0L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"></path>

      </svg>-->






        <section style="margin-top: -22%;">
          <v-parallax
                  :height="$vuetify.breakpoint.mdAndDown ? 200 : 600"
                  :src="$vuetify.breakpoint.mdAndDown ? require('../assets/soh1_small.jpg') : require('../assets/soh2.jpg')"
                  class="lift_me_up"
          >

          </v-parallax>
        </section>

      <v-row class="px-12" style="background:#e7e7e7;position: relative;margin-top: -10px;z-index: 1;">
        <v-col cols="12">
          <v-container  style="text-align: center;" fill-height>

            <v-card
                    class="mx-auto"

                    outlined
            >

              <v-card-text class="pb-0">
                <i>"Tack vare Hihat kan jag på ett enkelt <br>och roligt sätt tjäna pengar på mitt streamande"</i>
              </v-card-text>

              <v-card-text class="pt-0">
                <div class="overline"> <v-list-item-avatar
                        tile
                        size="40"
                        color="grey"
                >
                  <v-img src="/api/images/guthenbg.png"></v-img>

                </v-list-item-avatar>twitch.tv/Guthen</div>

              </v-card-text>


            </v-card>
          </v-container>
        </v-col>

      </v-row>











    </div>


    <v-dialog v-model="twitchDialog" max-width="400px">

      <v-card>
        <v-card-title>
          <span class="headline">Twitch-koppling</span>
        </v-card-title>
        <v-card-text>
          <v-container>



            <v-row align="center" justify="center">
              <v-col cols="12" style="text-align: center;">
                <v-btn v-if="$store.state.STREAMER.TWITCH_NAME===null" @click="linkTwitch" class="mx-auto" color="deep-purple darken-1" text>
                  Anslut till Twitch<v-icon right>mdi-twitch</v-icon>
                </v-btn>
                <v-btn v-else class="mx-auto" color="deep-purple darken-1" text>
                  <v-icon small  >mdi mdi-checkbox-marked-circle-outline</v-icon>{{$store.state.STREAMER.TWITCH_NAME}}<v-icon right>mdi-twitch</v-icon>
                </v-btn>

                <p v-if="$store.state.STREAMER.TWITCH_NAME===null"><small>Anslut ditt Hihat-konto till Twitch för att få ut det mesta och bästa ur Hicards </small></p>
                <p v-else ><small>Ditt Hihat-konto är redan anslutet till twitch-kontot "{{$store.state.STREAMER.TWITCH_NAME}}"</small></p>

              </v-col>
            </v-row>

          </v-container>
        </v-card-text>



      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import VideoGreet from "../components/VideoGreet"


export default {
  name: 'Home',
  components: {
    VideoGreet

  },
  data(){
    return{
      value: [90,22,10,85,100],
      twitchDialog:false
    }
  },
  computed:{
    leaderboardSticky:function(){
      return true
    },
    minHeight () {
      const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

      return `calc(${height} - ${this.$vuetify.application.top}px)`
    }
  },
  methods:{
    linkTwitch:function(){
      window.location.href="/api/link_twitch"
    }

  },
  watch:{
    '$store.getters.loggedIn':function(){
      if(this.$store.getters.loggedIn && this.$cookies.isKey("t")){
        if(this.$cookies.get("t")==="c"){
          this.$cookies.remove("t");
          this.twitchDialog=true;
          this.$router.replace({'t': null});
        }

      }
    }
  },

  mounted:function(){
    document.title="Hihat";
    if(this.$route.query.new==="twitch"){
      this.$store.state.APP.CREATE_PAGE=2;
      this.$store.state.APP.SHOW_CREATE=true;
      window.history.replaceState(null, null, window.location.pathname);

    }
    else if(this.$route.query.reset){
      this.$store.state.APP.SHOW_NEW_PASSWORD=true;

    }
    else if(this.$route.query.t==="c"){
      let self=this;
      setTimeout(function(){
        if(self.$store.getters.loggedIn){
          self.twitchDialog=true;
          self.$router.replace({'t': null});


        }
        else{
          self.$cookies.set("t","c");
          self.$store.state.APP.SHOW_LOGIN=true;
        }
      },800);



    }
    else if(this.$cookies.isKey("new_sl")){
      this.$store.state.APP.CREATE_PAGE=3;
      this.$store.state.APP.SHOW_CREATE=true;
      this.$cookies.remove("new_sl");
    }
    else if(this.$cookies.isKey("new_se")){
      this.$store.state.APP.CREATE_PAGE=3;
      this.$store.state.APP.SHOW_CREATE=true;
      this.$cookies.remove("new_se");
    }
    else if(this.$cookies.isKey("go_to")){
      let go_to=this.$cookies.get("go_to");

      this.$cookies.remove("go_to");
      if(go_to!==null && go_to!=="null")
      window.location.href="/"+go_to;
    }
  }

}
</script>

<style scoped>
  .lift_me_up> * img{
    top:-200px;
  }

  .clickable:hover{
    background:rgba(255,255,255,0.15);
  }
</style>
